import { pickAdminDashboardLocaleText } from "../locale/admin-dashboard-copy";
import type { AdminDashboardLocale } from "../locale/admin-dashboard-locale";

export function formatAdminSourceKindLabel(
  kind: "projection" | "request_outcome" | "job_projection" | "client_flow_event" | undefined,
  locale: AdminDashboardLocale,
): string {
  if (kind === "client_flow_event") {
    return pickAdminDashboardLocaleText(locale, { en: "client flow event", ko: "클라이언트 흐름 이벤트" });
  }

  if (kind === "request_outcome") {
    return pickAdminDashboardLocaleText(locale, { en: "request outcome", ko: "요청 결과" });
  }

  if (kind === "job_projection") {
    return pickAdminDashboardLocaleText(locale, { en: "job projection", ko: "작업 프로젝션" });
  }

  return pickAdminDashboardLocaleText(locale, { en: "projection", ko: "프로젝션" });
}
